import React, { useEffect, useRef } from "react"
import "../../styles/Benefits/BenefitModal.less"
import DynamicCard from "./DynamicCard"

import CloseButton from "./CloseButton"
import CircleIcon from "./CircleIcon"
import GenericModal from "./GenericModal"

import { observer } from "mobx-react"
import AppStore from "../../Configs/Store"
import BenefitStore from "../../Configs/Store/benefit"
import DOMPurify from "dompurify"

const CarousalModal = observer(
  ({
    modalWrapper = "modalWrapper",
    cardContainer = "ModalContainer",
    cardWrapperStyle = "DynamicCardModalWrapper",
    cardTitleStyle = "DynamicCardTitleModal",

    cardDotStyle = "DynamicCardDotModal",
    cardContentStyle = "DynamicCardBodyModal",
    cardIconStyle = "DynamicCardIconModal",
    titleBodyWrapperStyle = "DynamicCardTitleBodyWrapper",
    arrowUrl = null,
    cardArrowStyle = null,
    rootClassName = "BenefitModalRoot",

    ...props
  }) => {
    const device = AppStore.device

    const myRef = useRef(null)

    useEffect(() => {
      let scrollX =
        // AppStore.windowWidth * 0.4 +
        232 * BenefitStore.cardId - (AppStore.windowWidth - 320) / 2

      myRef.current?.scrollTo(scrollX, 0)
    }, [BenefitStore.cardId])
    console.log("Card Contents inside caraousal Modal is ==> ", props.cardContents)

    return (
      <>
        <GenericModal
          visibleState={props.visibleState}
          updateVisibility={props.updateVisibility}
          closeIcon={
            device === 0 ? (
              <CircleIcon
                iconUrl={`common/Path15589`}
                iconStyle="closeIconModalMob"
                // onClick={props.updateVisibility}
              />
            ) : (
              <div className="PCModalTextCrossWrapper">
                <CloseButton
                  className="closeIconModalPC"
                  // onClick={props.updateVisibility} Removed For Double Close Event Fire Fix
                  onClick={null}
                />
              </div>
            )
          }
          showButton={props.buttonShow}
          buttonText={props.buttonText}
          buttonWrapper={"calculateFormDiv"}
          buttononClick={props.buttonClick ? props.buttonClick : props.updateVisibility}
          buttonStyle={"MainButton"}
          rootClassAntCustom={rootClassName}
          component={
            <div className={modalWrapper}>
              {props.title && <div className="titleText" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.title) }}></div>}

              <div ref={myRef} className={cardContainer}>
                {props.cardContents.map((x, i) => (
                  <DynamicCard
                    key={"CarouselModal_" + i}
                    data={x}
                    modal={true}
                    dot={true}
                    arrow={true}
                    title={true}
                    content={true}
                    icon={true}
                    cross={props.cross}
                    crossOnClick={props.updateVisibility}
                    wrapperStyle={cardWrapperStyle}
                    titleStyle={cardTitleStyle}
                    contentStyle={cardContentStyle}
                    dotStyle={cardDotStyle}
                    arrowUrl={arrowUrl}
                    arrowStyle={cardArrowStyle}
                    iconStyle={cardIconStyle}
                    titleBodyWrapperStyle={titleBodyWrapperStyle}
                  />
                ))}
              </div>
              {device === 1 ? (
                <p style={{ position: "absolute", right: "80px", bottom: "0px", fontWeight: "bold", fontSize: "10px" }}>
                  <sup>~</sup>Conditions Apply
                </p>
              ) : (
                ""
              )}
            </div>
          }
        />
      </>
    )
  }
)

export default CarousalModal
